export const SET_JWT = 'SET_JWT';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const SET_USERS = 'SET_USERS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCTS_FILTERS = 'SET_PRODUCTS_FILTERS';
export const SET_TEMPLATES = 'SET_TEMPLATES';
